import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';

import { CatalogConfigLinkTile } from '../../../../catalog-config/model/catalog-config';


@Component({
  selector: 'p1-link-tile',
  templateUrl: './link-tile.component.html',
  styleUrls: ['./link-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkTileComponent {

  @Input()
  linkTile: CatalogConfigLinkTile;

  constructor() { }
}
